export default __webpack_public_path__ + "static/media/kitchen3-before1-1920w.3726f476.webp";